import { RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterStateUrl } from '../../router-state-serializer';

export const selectRouterFeature = createFeatureSelector<RouterReducerState<RouterStateUrl>>('router');

export const selectParams = createSelector(selectRouterFeature, router => router?.state?.params);

export const selectUrl = createSelector(selectRouterFeature, router => {
  if (router?.state !== undefined) {
    return router.state.url.substring(1, router.state.url.length);
  }
  return undefined;
});
